// extracted by mini-css-extract-plugin
module.exports = {"Subscribe":"J_nfPpBC","input":"HdtXl7N3","submit":"P9d3tu0E"};